import React from 'react'
import styled from 'styled-components'

const DividerSectionDiv = styled.div`
  margin-top: -1px;
  margin-bottom: -1px;
  height: auto;
  /* background-color: red; */

  ${(props) =>
    props.color ? 'background-color: ' + props.color + ';' : '#fff'}

  img {
    width: 100vw;
    ${(props) => (props.flip ? 'transform: rotate(180deg);' : '')}
  }

  /* 
   background-position: right;
   background-size: 110% 100%;
   
   
   width: 100vw; 
   */
`

const DividerSection = ({ colorType, color, flip }) => {
  return (
    <DividerSectionDiv colorType={colorType} color={color} flip={flip}>
      <img
        src={
          colorType == 1
            ? '/images/homepage-v2/divider.svg'
            : colorType == 1.5
              ? '/images/homepage-v2/divider-colored.svg'
              : colorType == 2
                ? '/images/homepage-v2/divider4.svg'
                : colorType == 3
                  ? '/images/homepage-v2/divider3.svg'
                  : colorType == 4
                    ? '/images/homepage-v2/divider4.svg'
                    : '/images/homepage-v2/divider5.svg'
        }
      />
    </DividerSectionDiv>
  )
}
export default DividerSection
